import React, { Component, Fragment } from 'react';
import API_URL from '../../ApiUrl';
import axios from 'axios';

class Accomodation extends Component {

    constructor(props) {
        super(props);
        this.divRef = React.createRef();
        this.state = {
            fullname: '',
            email: '',
            no_wa: '',
            id: this.props.match.params.id
        }
    }

    componentDidMount() {
        if (this.divRef.current) {
          this.divRef.current.focus();
        }
      }

    handleChange(e) {
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    payNow(harga) {
        // var formData = new FormData();

        // formData.append('nama_lengkap', this.state.fullname);
        // formData.append('email', this.state.email);
        // formData.append('no_wa', this.state.no_wa);

        // axios.post(API_URL.superStudent+'ihms/register', formData, {
        //     headers: { 
        //         'Accept': 'application/json'
        //     }
        // })
        // .then(response => response.data)
        // .then(result => {
        //     window.snap.pay(result, {
        //         onSuccess: function(result){console.log('success');console.log(result);},
        //         onPending: function(result){console.log('pending');console.log(result);},
        //         onError: function(result){console.log('error');console.log(result);},            
        //         onClose: function(){console.log('customer closed the popup without finishing the payment');}
        //     })
        // })
        // .catch(error => {
        //     console.log(error);
        // })
    }

    render() {
        return (
            <div>
                <section className='banner-accomodation' id="banner">
                    <div className='container'>
                        <div className='row text-white' style={{marginTop: '300px', marginBottom: '200px'}}>
                            <div className='col-lg-5'>
                                <h1><strong>IHMS</strong></h1>
                                <h3>Student Accomodation</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <main id="main">
                    <section ref={this.divRef} tabIndex={-1}>
                        <div className="container">
                            <div className="row mb-5 d-flex justify-content-center">
                                <div className="col-lg-6">
                                    {
                                        this.state.id === '1' ? 
                                        <div className="room-card">
                                            <h2 className="room-title">Private Room 1</h2>
                                            <p className="room-price">Rp 2.650.000/Month</p>
                                            <ul className="room-features">
                                                <li>✅ Toilet Dalam</li>
                                                <li>✅ WiFi</li>
                                                <li>✅ Cleaning Service 2x/week</li>
                                                <li>✅ AC</li>
                                                <li>✅ Full Furnished</li>
                                                <li>✅ Sharing Refrigerator</li>
                                                <li>✅ Free biaya kebersihan dan keamanan</li>
                                                <li>✅ Free Laundry</li>
                                                <li>✅ Water Heater</li>
                                            </ul>
                                            <button className="book-button" onClick={() => this.payNow(2650000)}>Pay Now</button>
                                        </div>
                                        :
                                        <div className="room-card">
                                            <h2 className="room-title">Private Room 2</h2>
                                            <p className="room-price">Rp 2.100.000/Month</p>
                                            <ul className="room-features">
                                                <li>✅ Toilet Luar</li>
                                                <li>✅ WiFi</li>
                                                <li>✅ Cleaning Service 2x/week</li>
                                                <li>✅ AC</li>
                                                <li>✅ Full Furnished</li>
                                                <li>✅ Sharing Refrigerator</li>
                                                <li>✅ Free biaya kebersihan dan keamanan</li>
                                                <li>✅ Free Laundry</li>
                                                <li>✅ Water Heater</li>
                                            </ul>
                                            <button className="book-button" onClick={() => this.payNow(2100000)}>Pay Now</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        )
    }

}

export default (Accomodation);